module.exports = __webpack_public_path__ + "static/media/axe-battle.ac1cb4c4.svg";